/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getId } from '@fluentui/react/lib/Utilities';
import { PredictionStore } from 'src/luis/projects/utterances/stores/predictionStore';
import { LuisId } from 'src/luis/types/Resource';
import { ResourceStore } from 'src/luis/types/stores/core/ResourceStore';

export class SuggestedUtteranceStore extends PredictionStore implements ResourceStore {
    public readonly id: LuisId;

    constructor(prediction: Partial<PredictionStore>) {
        super(prediction);
        this.id = getId();
    }
}
